import { CloseIcon } from "@forge/common";
import aboutUsImg from "../../assets/IAS.jpg";
import "./AboutUsPopup.scss";

export interface AboutUsPopupProps {
  heading: string;
  version: string;
  patent: string;
  onClose: () => void;
  imageClassName?: string;
}

const AboutUsPopup: React.FC<AboutUsPopupProps> = ({
  heading,
  version,
  patent,
  onClose,
  imageClassName = "aboutus-img w-[150px] h-[100px] xl-high:w-[250px] xl-high:h-[200px] ml-2",
}) => {
  const year = new Date().getFullYear();

  return (
    <div className="about-us-popup" data-testid="about-us-popup">
      <div className="flex justify-between">
        <p className="text-xl">{heading}</p>
        <CloseIcon
          id="aboutus-close-icon"
          data-testid="aboutus-close-icon"
          className="text-xl cursor-pointer"
          onClick={onClose}
        />
      </div>
      <div>
        <div className="flex justify-between items-center">
          <div className="aboutus-content">
            <p>{version}</p>
            <div>
              <p>{patent}</p>
              <p className="mb-1">
                Copyright {year}, Honeywell International Inc., All rights
                reserved
              </p>
              <div className="w-full flex justify-center">
                <button
                  id="end-user-button-id"
                  data-testid="end-user-button-id"
                  className="end-user-button"
                  onClick={() => {
                    window.open(
                      "/licenseAgreement/license-agreement.htm",
                      "_blank",
                      "noopener noreferrer"
                    );
                  }}
                >
                  End User License Agreement
                </button>
              </div>
            </div>
          </div>
          <img
            className={imageClassName}
            src={aboutUsImg}
            alt="About Us"
          />
        </div>
      </div>
    </div>
  );
};

export default AboutUsPopup;
